/* Painel do Administrador escolar — escopo escola.

   A escola vem de `user_roles[].school_id` (ver lib/escopo.js), então não há
   seleção: o painel abre já na unidade do usuário.

   AppShell trocado pelo PainelShell (D7). O breadcrumb de drill-down
   (escola › turma) é reportado de baixo pelo AdminPainelView. */

import React, { useState } from "react";

import { AdminPainelView } from "./AdminPainel";
import { Breadcrumb } from "../../components/layout/Breadcrumb";
import PainelShell from "../../components/PainelShell";
import { PeriodoFiltro } from "../../components/PeriodoFiltro";
import { periodoInicial } from "../../lib/periodo";
import { useContextoIE } from "../../lib/useContextoIE";

export function AdminApp() {
  const { contexto, carregando, erro } = useContextoIE("admin");
  const [meta, setMeta] = useState(null);
  const [periodo, setPeriodo] = useState(periodoInicial);
  const [breadcrumb, setBreadcrumb] = useState([]);

  if (carregando) {
    return (
      <PainelShell escopoLabel="Escola" escopoValor="carregando…">
        <p className="text-[13px] text-[var(--color-ink-faint)]">Carregando…</p>
      </PainelShell>
    );
  }
  if (erro || !contexto?.escolaId) {
    return (
      <PainelShell escopoLabel="Escola" escopoValor="carregando…">
        <p className="text-[13px] text-[var(--color-bad)]">
          {erro || "Não foi possível identificar a sua escola."}
        </p>
      </PainelShell>
    );
  }

  const ano = contexto.anos?.[0];
  const anoSel = ano ?? meta?.ano ?? undefined;
  const resumo = meta
    ? `${meta.alunos.toLocaleString("pt-BR")} alunos · ${meta.turmas} turma${
        meta.turmas === 1 ? "" : "s"
      }`
    : "";

  return (
    <PainelShell
      escopoLabel="Escola"
      escopoValor={[contexto.escolaNome, resumo].filter(Boolean).join(" · ")}
      breadcrumb={
        breadcrumb.length > 1 ? <Breadcrumb items={breadcrumb} /> : null
      }
      toolbar={
        <PeriodoFiltro estado={periodo} ano={anoSel} onChange={setPeriodo} />
      }
    >
      <AdminPainelView
        escolaId={contexto.escolaId}
        escolaNome={contexto.escolaNome}
        ano={ano}
        periodo={periodo}
        onMeta={setMeta}
        onBreadcrumb={setBreadcrumb}
      />
    </PainelShell>
  );
}
